module.exports = __webpack_public_path__ + "img/6.a9ab65e2.png";